import React, { useState } from 'react'
// import { getRGB } from '../../../lib/color'
import { DashboardContainer } from '../../funcs/utils';
import HoldingsTabs from './components/HoldingsTabs/HoldingsTabs';
import HoldingsTable from './components/HoldingsTable/HoldingsTable';
import HoldingsTabIcons from './components/HoldingsTabIcons/HoldingsTabIcons';
import HorizontalBar from './components/HorizontalBar';
import Donut from './components/Donut';
import LargestHoldings from './components/LargestHoldings/LargestHoldings';

export const ChartEnum = Object.freeze({
    DONUT: 'donut',
    HORIZONTAL_BAR: 'horizontal_bar'
  });

const HoldingsCard = ({ client, holdingsData, showCharts = true }) => {
    const tabs = [...Object.keys(holdingsData)];
    const [activeTab, setActiveTab] = useState(tabs[0]);
    const [activeChart, setActiveChart] = useState(ChartEnum.DONUT)
    const [tableRowId, setTableRowId] = useState(null);
    const [sortedData, setSortedData] = useState(holdingsData[activeTab].all_data);

    const isDonut = activeChart === ChartEnum.DONUT;
    const isHorizontalBar = activeChart === ChartEnum.HORIZONTAL_BAR;
    
    const donutMarginTop = 72;
    // const selectedColor = getRGB(client.color.sign_on_button);

    // i cant make the chart a presentational component because the content is not reusuable
    // the content is very unique, so it must have separate compartments

    return (
        <DashboardContainer title={"Holdings"} client={client}>
            {/* Charts */}
            {showCharts && 
                <div>
                    {/* Tab Icons */}
                    <div style={{ marginTop: '24px' }}>
                        <HoldingsTabIcons activeChart={activeChart} setActiveChart={setActiveChart}/>
                    </div>
 
                    {isDonut && 
                        <div style={{ marginTop: '48px' }}>
                             <div>
                                <LargestHoldings data={holdingsData[activeTab].all_data} largestHoldings={holdingsData[activeTab].largest_holdings} />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Donut data={holdingsData[activeTab].all_data} largestHoldings={holdingsData[activeTab].largest_holdings} tableRowId={tableRowId} />
                            </div>
                        </div>
                    }
                    {isHorizontalBar && 
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <HorizontalBar data={sortedData} donutMarginTop={donutMarginTop} tableRowId={tableRowId} />
                        </div>
                    }
                </div>
            }
            
            
            {/* Table */}
            <React.Fragment>
                {/* Tab Buttons */}
                <div style={{ backgroundColor: '#fff', borderBottom: '1px solid #bfbfbf', marginTop: '72px' }}>
                    <HoldingsTabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
                </div>
                
                {/* Tab Content */}
                <div style={{ maxHeight: '500px', overflow: 'auto', border: '1px solid #bfbfbf', borderTop: "none" }}>
                    <HoldingsTable data={holdingsData[activeTab].all_data} activeTab={activeTab} setTableRowId={setTableRowId} setSortedDataToParent={setSortedData} />
                </div>
            </React.Fragment>
        </DashboardContainer>
    )
}

export default HoldingsCard